import { render } from "./bank.vue?vue&type=template&id=770bdc12"
import script from "./bank.vue?vue&type=script&lang=js"
export * from "./bank.vue?vue&type=script&lang=js"

import "./bank.vue?vue&type=style&index=0&id=770bdc12&lang=css"

import exportComponent from "/Users/arthaskyline/Documents/FILE_DELFIN/kodingan-arthaskyline/level-up/levelup-github/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__